import { usePlanOverageUsageData } from 'assets/js/pages/account-settings/account-about/givebutter-plus/usePlanOverageUsageData';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useRecommendedPlanComparison } from 'customHooks/useRecommendedPlanComparison';

const eventProperties = {
    over80: 'Over 80 Warning',
    over90: 'Over 90 Warning',
    over100: 'Over 100 Warning',
    recommendedPlan: 'Prompt for Recommended Plan',
};

const useOveragePosthogProperties = () => {
    const { validGivebutterPlusPlan } = useCurrentAccount();
    const { isRecommendedPlanCheaper } = useRecommendedPlanComparison();
    const { over80, over90, over100, isGracePeriod, hasOverages } = usePlanOverageUsageData();

    if (!validGivebutterPlusPlan) {
        return {
            isGracePeriod: null,
            type: null,
        };
    }

    const getPhaseType = () => {
        if (hasOverages && isRecommendedPlanCheaper) {
            return eventProperties.recommendedPlan;
        } else if (over100) {
            return eventProperties.over100;
        } else if (over90) {
            return eventProperties.over90;
        } else if (over80) {
            return eventProperties.over80;
        }

        return null;
    };

    return {
        isGracePeriod,
        type: getPhaseType(),
    };
};

export { useOveragePosthogProperties };
